import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { GROWTH_YEARS, GROWTH_LINES } from '../data/mockData';

// 区块4：大学四年五维能力成长曲线（面积图）
export default function ChartLineGrowth() {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '大学四年五维能力成长曲线',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: GROWTH_LINES.map((l) => l.name),
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    grid: { left: '3%', right: '4%', bottom: '12%', top: '16%', containLabel: true },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: GROWTH_YEARS,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#e2e8f0', fontSize: 15, fontWeight: 'bold' },
    },
    yAxis: {
      type: 'value',
      max: 100,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#94a3b8', fontSize: 13 },
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } },
    },
    series: GROWTH_LINES.map((line) => ({
      name: line.name,
      type: 'line',
      smooth: true,
      data: line.data,
      itemStyle: { color: line.color },
      lineStyle: { width: 3 },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: line.color + '66' },
          { offset: 1, color: line.color + '08' },
        ]),
      },
      symbol: 'circle',
      symbolSize: 8,
      label: {
        show: true,
        position: 'top',
        color: line.color,
        fontSize: 12,
      },
      animationDuration: 1500,
    })),
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 480 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
